export default class ValidationException {
  errors = {};

  constructor(errors) {
    this.getErrors(errors);
  }

  getErrors(errors) {
    errors.forEach((error) => {
      if (!error.children.length) {
        const { constraints } = error;
        this.errors[error.property] = Object.keys(constraints).map((k) => {
          return constraints[k];
        });
      } else {
        this.getErrors(error.children);
      }
    });
  }
}
